import React from "react";
import H from "../../../common/Typography/H";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircleOutline";

import styles from "./banned-info.module.scss";

function BannedInfo() {
  return (
    <H level={3} className={styles.root}>
      <span className={styles.icon}>
        <RemoveCircleIcon />
      </span>
      <span>
        Данный дизайн был заблокирован по требованию правообладателя. Вы можете
        создать товар с любым своим принтом в{` `}
        <a href="/products">нашем редакторе</a>.
      </span>
    </H>
  );
}

export default BannedInfo;
